import React from "react";
import "../../styles/aboutUs.css"; 
import about from "../../assets/abthome.jpeg"


const AboutUs = () => {
  return (
    <section className="about-section">
      <div className="about-container">
        
        {/* LEFT SIDE: IMAGE */}
        <div className="about-image-side">
          {/* Using a placeholder graduation image to match the context */}
          <img 
            src={about}
            alt="Degree Students Graduation" 
            className="about-img"
          />
        </div>

        {/* RIGHT SIDE: TEXT */}
        <div className="about-text-side">
          <h2 className="about-title">Why Madhi Academy for <br /> Degree Students?</h2>
          
          <p className="about-description">
            At Madhi Academy – Global Courses Division, we specialize in guiding 
            ambitious professionals towards internationally recognized qualifications.
            Our mission is simple: to transform local talent into global professionals.
          </p>

          {/* FEATURE LIST */}
          <div className="about-features">
            
            {/* Item 1 */}
            <div className="feature-item">
              <div className="icon-circle">
                <i className="bi bi-book-half"></i> 
              </div>
              <span className="feature-text">
                <strong>Flexible Learning</strong> – Online degree classes without compulsory attendance.
              </span>
            </div>

            {/* Item 2 */}
            <div className="feature-item">
              <div className="icon-circle">
                <i className="bi bi-award"></i>
              </div>
              <span className="feature-text">
                <strong>Dual Qualification</strong> – Degree + CA / CMA / CS / ACCA coaching.
              </span>
            </div>

            {/* Item 3 */}
            <div className="feature-item">
              <div className="icon-circle">
                <i className="bi bi-wallet2"></i>
              </div>
              <span className="feature-text">
                <strong>Affordable Fees</strong> – Installment options for students.
              </span>
            </div>

            {/* Item 4 */}
            <div className="feature-item">
              <div className="icon-circle">
                <i className="bi bi-laptop"></i>
              </div>
              <span className="feature-text">
                <strong>Job-Ready Skills</strong> – Tally, Zoho, GST, Excel, Communication Training included.
              </span>
            </div>

             {/* Item 5 */}
             <div className="feature-item">
              <div className="icon-circle">
                <i className="bi bi-briefcase"></i>
              </div>
              <span className="feature-text">
                <strong>Placement Assistance</strong> – Career support after graduation.
              </span>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
};

export default AboutUs;